import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Point } from 'geojson';
import { LatLngBounds } from 'leaflet';
import { MapComponent } from 'src/app/components/geo/map/map.component';
import { UtilService } from 'src/app/services/util.service';
import { ErrorService } from '../../../services/error.service';
import { ClusterDefinition, MinMaxPoints } from '../../../services/global/global-interfaces';

@Component({
  selector: 'sb-comp-cluster-map',
  templateUrl: './sb-cluster-map.component.html',
  styleUrls: ['./sb-cluster-map.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SbClusterMapComponent implements OnInit, OnChanges {
  @Input() mapHeight: number;

  @Input() loading: boolean;
  debounceTimer: ReturnType<typeof setTimeout> = null;

  @Input() clusters: ClusterDefinition[];

  @Input() mapCenter: { x: number; y: number } = { x: 10.447683, y: 51.163361 };
  @Input() mapZoom: number = 6;

  min: Point;
  max: Point;

  @Output() minMaxPointsChange: EventEmitter<MinMaxPoints> = new EventEmitter<MinMaxPoints>();

  mapComponent: MapComponent;

  constructor(
    public errorHandler: ErrorService,
    public util: UtilService
  ) {}

  ngOnInit() {}

  mapReady(mapComponent: MapComponent) {
    this.mapComponent = mapComponent;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.emitDebounced(); //remove this, produces endless loop
  }

  refreshBounds() {
    if (this.mapComponent) {
      const boundingRectangle: LatLngBounds = this.mapComponent.getBoundingRectangle();
      if (boundingRectangle) {
        this.min = this.util.geo.createPoint(boundingRectangle.getWest(), boundingRectangle.getNorth());
        this.max = this.util.geo.createPoint(boundingRectangle.getEast(), boundingRectangle.getSouth());
      }
      this.emitDebounced();
    }
  }

  emitDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.emit();
    }, 1000);
  }

  emit() {
    this.minMaxPointsChange.emit({ min: this.min, max: this.max });
  }
}
